import React from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import styles from "./ContactNumberInput.module.css";
import CommonStyles from "../InputFieldsController/InputFieldsController.module.css";

import {
  FieldProps,
  getFieldContainerStyle,
} from "../InputFieldsController/InputFieldsController.utils";
import LabeledInputWrapper from "../InputFieldsController/LabeledInputWrapper";

interface ContactNumberInputProps {
  field: FieldProps;
  handleChange: (fieldId: string, event: any) => void;
  handleBlur: (fieldId: string) => void;
  handleSelect: (fieldId: string) => void;
}

/**
 * ContactNumberInput renders a phone number input field using `react-phone-number-input`.
 * It supports validation, formatting, and flexible layout through CygnusForm.
 *
 * @component
 * @param {Object} props - Component props
 * @param {FieldProps} props.field - The field definition and metadata
 * @param {(fieldId: string, event: any) => void} props.handleChange - Function to handle value updates
 */
const ContactNumberInput: React.FC<ContactNumberInputProps> = ({
  field,
  handleChange,
  handleBlur,
  handleSelect,
}) => {
  const {
    id,
    value,
    example,
    show = true,
    isValid = true,
    error,
    disabled,
    selected,
  } = field;

  if (!show) return null;

  const containerStyle = getFieldContainerStyle(field);

  return (
    <div style={containerStyle}>
      <LabeledInputWrapper field={field}>
        <PhoneInput
          id={id}
          international
          defaultCountry="US"
          value={value}
          disabled={disabled}
          onChange={(phone) => handleChange(id, { target: { value: phone } })}
          onBlur={() => handleBlur(id)}
          onFocus={() => handleSelect(id)}
          className={`${styles.customContactInput} ${
            selected ? CommonStyles.selectedField : ""
          } ${!isValid ? "is-invalid" : ""}`}
        />
      </LabeledInputWrapper>
      {!isValid && error && <div className="invalid-feedback">{error}</div>}

      {example && <small className="text-muted">Example: {example}</small>}
    </div>
  );
};

export default ContactNumberInput;
